export class Patterns {
  static readonly password =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.$!%*?&#_-])[A-Za-z\d@$!%*.?&#_-]{8,}$/;
  static readonly emptyUUID = /^([0]{8}-[0]{4}-[0]{4}-[0]{4}-[0]{12})$/;
}
